let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bXZjq")).then(() => parcelRequire('iQb6E'));